export default __webpack_public_path__ + "dc25ea0b2aed7b40a5e0a32b48322b28.png";